import React, {useEffect, useState} from "react";
import {Table, Form, Input, Select, Button, Space, Card, Row, Col, Switch, message, Modal, Popconfirm, Tooltip} from "antd";
import {SearchOutlined, EditOutlined, DeleteOutlined} from "@ant-design/icons";
import styles from "./teacherManager.module.css";
import {LeftOutlined, RightOutlined} from '@ant-design/icons';

import {Pagination} from 'antd';

import CommonModal from './add/Common.js'
import EditSchoolMemberModal from './editSchoolMember/Common.js'

import {
    getInfoListRequest,
    changeAdminStatusRequest,
    deleteSchoolTeacherRequest
} from "./api";
import {closeHomePage, openLogin} from "../../../store/modalsSlice";
import settingIcon from "./setting.svg";
import openGuideIcon from "./openGuide.svg";
import {useDispatch} from "react-redux";
import InfoItem from "./InfoItem";
import { clearAllCookies } from "../../../util/handleObject.js";
import { setShowPlayerModalStatus, setVideoId } from "../../PlayerModal/PlayerModalSlice.js";
import Cookies from 'js-cookie';
const {Option} = Select;

const TeacherManager = () => {

    const dispatch = useDispatch();
    // 筛选表单状态
    const [filterForm, setFilterForm] = useState({
        name: "",
        status: ""
    });
    const [dataList, setDataList] = useState([]);
    // 分页状态

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isShowEditCommon, setIsShowEditCommon] = useState(false);
    const [isShowEditSchoolMember, setIsShowEditSchoolMember] = useState(false);
    const [editUser, setEditUser] = useState({
        name: "",
    });
    const [totalNumber, setTotalNumber] = useState(0);
    const [limit, setLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [messageApi, contextHolder] = message.useMessage();


    const [user, setUser] = useState({
        name: "",
        email: ""
    });

    useEffect(() => {
        getUserList(filterForm.name, filterForm.status, (currentPage - 1) * limit, limit)
    }, []); // 空数组意味着这个 effect 只会在组件挂载时执行一次

    function getUserList(namekey, status, offset, limit) {
        getInfoListRequest(namekey, status, offset, limit, (data) => {
            // getInfoListRequest("","", "", offset, limit, (data) => {
            console.log(data);
            if (data.ret === '1') {
                setDataList(data.data.data)
                setTotalNumber(data.data.total_num)
            } else {
                setDataList([])
                setTotalNumber(0)
            }
        });
    }

    function deleteUser(username) {
        deleteSchoolTeacherRequest(username, (data) => {
            if (data.ret === '1') {
                message.success("删除成功", 1);
                if(currentPage > 1&&dataList.length==1) {
                    getUserList(filterForm.name, filterForm.status, (currentPage - 2) * limit, limit)
                    setCurrentPage(currentPage - 1)
                }
                else {
                    getUserList(filterForm.name, filterForm.status, (currentPage - 1) * limit, limit)
                }

            } else {
                message.error(data.msg);
            }
        });
    }

    function closeCommonModal() {
        setIsModalVisible(false)
        setIsShowEditCommon(false)
        setIsShowEditSchoolMember(false)
    };

    function updateData() {
        getUserList(filterForm.name, filterForm.status, (currentPage - 1) * limit, limit)
    }

    // 处理状态切换
    const handleStatusChange = (info, checked) => {
        var status = checked ? '1' : '3';
        var username = info.username;
        changeAdminStatusRequest(username, status, (data) => {
            if (data.ret === '1') {
                setDataList(dataList.map(user =>
                    user.username === username ? {...user, status: checked} : user
                ));
            } else {
                message.error(data.msg, 1);
            }
        });


    };

    // 处理删除操作
    const handleDelete = (info) => {
        console.log(info);
        Modal.confirm({
            title: '确认删除',
            content: '确定要删除账号' + info.user_login + '吗？删除后不可恢复',
            okText: '确定',
            // okType: 'danger',
            cancelText: '取消',
            onOk() {
                console.log('用户点击了确定');
                // 在这里调用删除API
                deleteUser(info.username)
            },
            onCancel() {
                console.log('用户点击了取消');
            },
        });
    };


    // 处理筛选表单变化
    const handleFilterChange = (name, value) => {
        setFilterForm({
            ...filterForm,
            [name]: value
        });
    };

    // 处理筛选提交
    const handleFilterSubmit = () => {
        setCurrentPage(1)
        getUserList(filterForm.name, filterForm.status, 0, limit)

    };

    // 处理重置筛选
    const handleResetFilter = () => {
        setFilterForm({
            name: "",
            status: ""
        });
        // 重置后重新获取所有数据
    };

    const onShowSizeChange = (page, pageSize) => {
        //pageSize 变化的回调
        console.log(page, pageSize);
        setCurrentPage(1)
        setLimit(pageSize)
    };

    const onChangePage = (current, pageSize) => {
        //页码或 pageSize 改变的回调，参数是改变后的页码及每页条数
        setCurrentPage(current)
        getUserList(filterForm.name, filterForm.status, (current - 1) * pageSize, pageSize)

    };


    return (

        <div className={styles.background}>
            {contextHolder}
            <div className={styles.rightMenus}>
                <div className={styles["div-top"]}>
                    <h3 style={{marginLeft: 30}}>{Cookies.get("school_name")}-用户管理</h3>

                    <Popconfirm
                        placement="bottom"
                        title={""}
                        description={"是否退出登录"}
                        okText="是"
                        cancelText="否"
                        onConfirm={(e) => {
                            sessionStorage.clear()
                            clearAllCookies()
                            dispatch(closeHomePage())
                            dispatch(openLogin())
                        }}
                    >
                        <div className={styles.iconContainer}>
                            <img src={settingIcon} style={{width: '20px', height: '20px'}}/>
                        </div>
                    </Popconfirm>

                    <div className={styles.openGuide}
                    onClick={()=>{
                        dispatch(setShowPlayerModalStatus(true))
                        dispatch(setVideoId('70daaf36c9ea71f08711752281ec0102'))
                    }}>
                        <img src={openGuideIcon} style={{width: '20px', height: '20px'}}/>
                        开通指南
                    </div>

                    <Button
                        className={styles["bt-refresh"]}
                        type="primary"
                        onClick={(e)=>{
                            getUserList(filterForm.name, filterForm.status, (currentPage - 1) * limit, limit)
                        }}
                    >
                        刷新
                    </Button>
                </div>


                <Card title="" className={styles["card-top"]}>

                    <div className={styles["div-shaixuan"]}>
                        <div>数据筛选</div>

                        <Space className={styles["bt-shaixuan2"]}>
                            <Button onClick={handleResetFilter}>重置</Button>
                            <Button
                                type="primary"
                                onClick={handleFilterSubmit}
                            >
                                查询
                            </Button>

                        </Space>

                    </div>
                    <Row gutter={24} align="middle">
                        <Col span={6}
                        >
                            <Row align="middle">
                                <Col flex="50px"
                                >
                                    用户名
                                </Col>
                                <Col
                                    // flex="auto"
                                    style={{width: "calc(100% - 50px)"}}
                                >
                                    <Input
                                        placeholder="用户名"
                                        value={filterForm.name}
                                        onChange={(e) => handleFilterChange("name", e.target.value)}
                                    />
                                </Col>
                            </Row>
                        </Col>
                        <Col

                        >
                            <Row align="middle">
                                <Col flex="40px"
                                >
                                    状态
                                </Col>
                                <Col
                                    // flex="auto"
                                    style={{width: "calc(100% - 50px)"}}
                                    justify="start"
                                >
                                    <Select
                                        placeholder="状态"
                                        value={filterForm.status}
                                        onChange={(value) => handleFilterChange("status", value)}
                                    >
                                        <Option value="">全部</Option>
                                        <Option value="1">正常</Option>
                                        <Option value="3">禁用</Option>
                                    </Select>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>

                <Card title="" className={styles["card-bottom"]}>
                    <div className={styles["container-list"]}>

                        <div className={styles["div-shaixuan"]}>
                            <div>数据列表</div>

                            <Button
                                style={{marginLeft: 'auto'}}
                                type="primary"
                                onClick={() => {
                                    setIsModalVisible(true)
                                }}
                            >
                                添加
                            </Button>

                        </div>


                        <div className={styles.tableContainer}>
                            <table className={styles.infoTable}>
                                <tr
                                    className={styles.tr1}
                                >
                                    <td
                                        className={styles.td1}
                                    >用户姓名
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >手机号（账号）
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >剩余分配积分
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >剩余充值积分
                                    </td>
                                    {/*<td*/}
                                    {/*    className={styles.td2}*/}
                                    {/*>可用积分额度*/}
                                    {/*</td>*/}
                                    {/*<td*/}
                                    {/*    className={styles.td2}*/}
                                    {/*>充值积分总数额*/}
                                    {/*</td>*/}
                                    {/*<td*/}
                                    {/*    className={styles.td2}*/}
                                    {/*>剩余积分数额*/}
                                    {/*</td>*/}
                                    <td
                                        className={styles.td2}
                                    >账号状态
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >创建时间
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >操作
                                    </td>
                                </tr>
                                {dataList.map((item, index) => (
                                    <InfoItem
                                        item={item}
                                        key={index + 1}
                                        index={index + 1}
                                        editMethod={(info) => {
                                            console.log(info)
                                            setEditUser(info)
                                            setIsShowEditSchoolMember(true)
                                        }}
                                        deleteMethod={(info) => {
                                            handleDelete(info)
                                        }}
                                        changeStatus={(info,checked) => {
                                            handleStatusChange(info,checked)
                                        }}
                                    />
                                ))}
                            </table>

                            {/* 分页控件 - 右下角 */}

                        </div>
                        <Pagination
                            hideOnSinglePage={false}//只有一页隐藏分页器
                            align="end"
                            style={{marginTop: 20}}
                            showSizeChanger //是否展示 pageSize 切换器，当 total 大于 50 时默认为 true
                            onShowSizeChange={onShowSizeChange}//pageSize 变化的回调
                            defaultCurrent={1}
                            current={currentPage}
                            total={totalNumber}
                            locale={{
                                items_per_page: '条/页',  // 将 "/page" 改为 "/页"
                            }}
                            pageSizeOptions={['10', '20', '30']} // 自定义选项值
                            pageSize={limit}
                            onChange={onChangePage}
                            showLessItems={false} // 关闭"简化显示"模式
                        />
                    </div>
                </Card>
            </div>

            {isModalVisible?
            //添加账户的弹框
            <CommonModal
                updateData={updateData}
                openStatus = {isModalVisible}
                closeCommonModal={closeCommonModal}
                refreshList={(e)=>{
                    setFilterForm({
                        name: '',
                        status: '',
                    })
                    setCurrentPage(1)
                    getUserList("", "", 0, limit)
                }}
            />:null}
            {isShowEditSchoolMember?
            <EditSchoolMemberModal
                user={editUser}
                updateData={updateData}
                closeCommonModal={closeCommonModal}
                openStatus = {isShowEditSchoolMember}
                refreshList={(e)=>{
                    getUserList(filterForm.name, filterForm.status, (currentPage - 1) * limit, limit)
                }}
            />:null}


        </div>
    );
};

export default TeacherManager;

